import React from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { DropdownButton, Dropdown } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import i18n from "../../i18n";
import { formatCurrency, formatDate, getTablePageSize } from "../../helpers/formatUtils";

const EnhancedResultsTable = ({ data, language, showStore, balanceFormatLocaleOverride, trnTableDateFormatLocaleOverride, defaultEnhancedPageSize, showPageSizeOptions, customNS, currencySymbolFormatOverride, dateErrorMsg }) => {
  const { transactions, requestedCurrency } = data;

  const defaultPageSize = getTablePageSize(data.length, defaultEnhancedPageSize);

  const columns = [
    {
      dataField: "thistTrnTstmp",
      text: i18n.t("Date", {ns: customNS}),
      sort: true,
      formatter: cell => formatDate(customNS, cell, dateErrorMsg, true, trnTableDateFormatLocaleOverride || language),
      attrs: { tabIndex: '0' }
    },
    {
      dataField: "thistOutPosAmount",
      text: i18n.t("Amount", {ns: customNS}),
      sort: true,
      formatter: (cell, row) => formatCurrency(balanceFormatLocaleOverride || language, row.thistInCurrency || requestedCurrency, currencySymbolFormatOverride, cell),
      attrs: { tabIndex: '0' }
    },
    {
      dataField: "thistTransCode",
      text: i18n.t("Description", {ns: customNS}),
      sort: true,
      formatter: cell => i18n.t(`transaction.code.${cell}`, {ns: customNS}),
      attrs: { tabIndex: '0' }
    }
  ];

  if (showStore) {
    columns.push({
      dataField: "thistDealerNum",
      text: i18n.t("Store", {ns: customNS}),
      sort: true,
      formatter: null,
      attrs: { tabIndex: '0' }
    });
  }

  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange
  }) => (
      <div className="btn-group" role="group">
          <DropdownButton
            drop="up"
            variant="secondary"
            title={currSizePerPage}
            id="dropdown-button-drop-up"
          >
            {
              options.map(option => (
                <Dropdown.Item eventKey={option.text} key={option.text} onClick={() => onSizePerPageChange(option.page)}>{option.text}</Dropdown.Item>
              ))
            }
          </DropdownButton>
      </div>
    );


  const options = {
    paginationSize: 3,
    pageStartIndex: 1,
    alwaysShowAllBtns: true, // Always show next and previous button
    withFirstAndLast: false,
    hidePageListOnlyOnePage: true,
    prePageText: i18n.t("Prev", {ns: customNS}),
    nextPageText: i18n.t("Next", {ns: customNS}),
    prePageTitle: i18n.t("Go to previous", {ns: customNS}),
    nextPageTitle: i18n.t("Go to next", {ns: customNS}),
    totalSize: data.length,
    sizePerPageRenderer,
    sizePerPageList: [defaultPageSize, 15, 20, 25]
  };

  if (!showPageSizeOptions) {
    options['sizePerPageList'] = [defaultPageSize];
  }

  return (
    <div className="enhancedResultsTable">
      <BootstrapTable
        bootstrap4
        exportCSV
        striped
        hover
        responsive
        keyField="thistTrnTstmp"
        data={transactions}
        columns={columns}
        pagination={paginationFactory(options)}
      />
    </div>
  );
};

export default EnhancedResultsTable;
